








































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Global from '@/global';

@Component
export default class SearchFilter extends Vue {
  @Prop() private readonly sortOptions!: string[];
  @Prop() private readonly orderOptions!: string[];
  @Prop() private sort!: string;
  @Prop() private order!: string;
  @Prop() private perPage!: number;
  @Prop() private readonly disableFilters!: boolean;

  private currentSort: string = this.sort;
  private currentOrder: string = this.order;
  private currentPerPage: number = this.perPage;
  private perPageOptions: number[] = Global.perPageOptions;

  @Watch('currentPerPage')
  @Watch('currentOrder')
  @Watch('currentSort')
  private filtersChange(): void {
    this.$emit('filtersChange', {
      perPage: this.currentPerPage,
      sort: this.currentSort,
      order: this.currentOrder,
    });
  }
}
